import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Banner = styled(FlexContainer)`
  padding: var(--big-padding);
  border-radius: var(--semi-medium-border-radius);
  background: var(--red-dark-opacity-light);
`;

const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--xsmall-padding);
`;

const BannerActionLabel = styled.span`
  background-color: var(--white-main);
  color: var(--red-main);
  padding: var(--xxsmall-padding) var(--small-padding);
  border-radius: var(--medium-border-radius);
  font-size: var(--xsmall-font-size);
  font-weight: 500;
  align-self: flex-start;
  margin-top: var(--xxxsmall-padding);
`;

const BannerMessage = styled.h2`
  color: var(--red-dark);
  font-size: var(--heading-medium-font-size);
  font-style: normal;
  font-weight: 600;
  max-width: 550px;
  margin-top: 0;
  margin-bottom: 0;

  strong {
    font-weight: 700;
  }
`;

type WhitelistingBannerProps = {
  id: string;
  onStartWhitelisting?: () => void;
  className?: string;
};

export const WhitelistingBanner: React.FC<WhitelistingBannerProps> = ({
  id,
  onStartWhitelisting,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Banner justify="space-between" align="center" className={className}>
      <BannerContent>
        <BannerActionLabel>
          <span
            dangerouslySetInnerHTML={{
              __html: t('phishing.simulations.banner.actionLabel'),
            }}
          />
        </BannerActionLabel>
        <BannerMessage
          dangerouslySetInnerHTML={{
            __html: t('phishing.simulations.banner.message'),
          }}
        />
      </BannerContent>
      <AppButton id={id} onClick={onStartWhitelisting}>
        <span className="mr-2">
          {t('phishing.simulations.banner.startWhitelisting')}
        </span>
      </AppButton>
    </Banner>
  );
};
